module.exports = __webpack_public_path__ + "img/session4_bg.8c96bd8f.jpg";